import store from "@/store";

export const PRIVILEGE_OFFERS_READ = "offers_read";
export const PRIVILEGE_OFFERS_WRITE = "offers_write";
export const PRIVILEGE_ENTRIES_READ = "entries_read";
export const PRIVILEGE_ENTRIES_DOWNLOAD = "entries_download";
export const PRIVILEGE_ENTRIES_CHANGE_STATUS = "entries_change_status";
export const PRIVILEGE_ENTRY_MAIL_TEMPLATE_WRITE = "entry_mail_template_write";
export const PRIVILEGE_FILES_READ = "files_read";
export const PRIVILEGE_COMPANY_PROPS_WRITE = "company_props_write";
export const PRIVILEGE_SCOUT = "scout";

export const PRIVILEGE_AGENT_SCOUT = "agent_scout";

export function hasPrivilege(predicate: string) {
  const partnerUser = store.state.domains.user.partnerUser;
  if (!partnerUser) return false;

  const privileges = partnerUser.privileges;
  if (!privileges) return false;

  return privileges.includes(predicate);
}
